import { render } from "./glassitem-stage.vue?vue&type=template&id=896a1c86"
import script from "./glassitem-stage.vue?vue&type=script&lang=js"
export * from "./glassitem-stage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__